import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, SelectBox } from 'devextreme-react';
import { orderService } from '../services/order-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { useNavigate } from 'react-router-dom';
import OrderStatusCell from './components/order-status-celll';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';

const OrderList = () => {

    let startDate = new Date();
    let endDate = new Date();

    startDate.setDate(startDate.getDate() - 7);

    const dateLabel = { 'aria-label': 'Date' };

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id", "orderTypeCode", "supplierStatusCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        const x = await orderService.getOrderList(startDate, endDate, typeValue);
        return x;
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        startDate = e.value;
    }, []);

    const onValueChangedEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        endDate = e.value;
    }, []);

    const navigate = useNavigate();
    const goToDetail = (id: string, type: string, supplierStatusCode: string) => {

        if (type == "additional_order" && supplierStatusCode == "D") {
            navigate(`/syncflow/additional-order/${id}`, { state: { id: id } })
        } else {
            navigate(`/syncflow/order-detail/${id}`, { state: { id: id } })
        }
    }

    const order_product_count_cell_render = (data: any) => { return data.row.data.productCount + " / " + data.row.data.vendorProductCount }
    const order_qty_cell_render = (data: any) => { return data.row.data.orderQty + " / " + data.row.data.venderApprovedQty }
    const order_amount_cell_render = (data: any) => { return "$" + data.row.data.orderAmount + " / $" + data.row.data.vendorAmount }
    const order_supplier_status_cell_render = (data: any) => {

        if (data.row.data.supplierStatusCode == 'N')
            return <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_supplier_status_' + data.row.data.supplierStatusCode)}</span>
        if (data.row.data.supplierStatusCode == 'R')
            return <span className="text-danger fw-bold text-hover-danger d-block fs-6 ">{t('syncflow:lb_order_supplier_status_' + data.row.data.supplierStatusCode)}</span>
        if (data.row.data.supplierStatusCode == 'A' && data.row.data.orderQty == data.row.data.venderApprovedQty)
            return <span className="text-success fw-bold text-hover-success d-block fs-6 ">{t('syncflow:lb_order_supplier_status_' + data.row.data.supplierStatusCode)}</span>
        if (data.row.data.supplierStatusCode == 'A' && data.row.data.orderQty != data.row.data.venderApprovedQty)
            return <span className="text-warning fw-bold text-hover-warning d-block fs-6 ">{t('syncflow:lb_order_supplier_status_' + data.row.data.supplierStatusCode)}</span>
    }
    const order_status_cell_render = (data: any) => (t('syncflow:lb_order_status_' + data.statusCode));

    const orderTypes = [{
        code: "additional_order",
        name: 'Additonal Order',
    },
    {
        code: "pre_order",
        name: 'Pre Order',
    }
    ];

    var [typeValue, setTypeValue] = useState("");
    const onValueChangedTypes = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setTypeValue(e.value)
        typeValue = e.value;
    }, []);

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row mb-12">
                <label className="col-lg-1 col-form-label fw-bold fs-6"> {t("syncflow:lb_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={startDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_end_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={endDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedEndDate}
                            />
                        </div>
                    </div>
                </div>
 
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_type")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="orderTypesLookup"
                                items={orderTypes}
                                onValueChanged={onValueChangedTypes}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'orderTypeCode',
                            caption: "Type",
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return t('syncflow:lb_order_type_' + data.data.orderTypeCode)
                            },
                        },
                        {
                            dataField: 'sourceName',
                            caption: t('syncflow:location_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'targetName',
                            caption: t('syncflow:lb_vendor'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderCode',
                            caption: t('syncflow:lb_order_number'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderDate',
                            caption: t('syncflow:lb_order_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'cutoff',
                            caption: t('syncflow:lb_cutoff'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: "datetime",
                            format: "hh:mm a",
                        },
                        {
                            dataField: 'deliveryDate',
                            caption: t('syncflow:lb_delivery_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },

                        {
                            dataField: 'productCount',
                            caption: t('syncflow:lb_product_count'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={(account?.productCount + " / " + account?.vendorProductCount)} />
                                )
                            },
                        },
                        {
                            dataField: 'orderQty',
                            caption: t('syncflow:lb_order_quantity') + ' / ' + t('syncflow:lb_supplier_approved_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={(account?.orderQty + " / " + account?.venderApprovedQty)} />
                                )
                            },
                        },
                        {
                            dataField: 'orderAmount',
                            caption: t('syncflow:lb_order_amount') + ' / ' + t('syncflow:lb_supplier_approved_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={("$ " + account?.orderAmount + " / " + "$ " + account?.vendorAmount)} />
                                )
                            },

                        },
                        {
                            dataField: 'supplierStatusCode',
                            caption: t('syncflow:lb_order_supplier_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={t('syncflow:lb_order_supplier_status_' + account?.supplierStatusCode)} ></OrderStatusCell>
                                )
                            },
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => goToDetail(data.key.id, data.key.orderTypeCode, data.key.supplierStatusCode)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default OrderList